import i18n from "i18next";
import k from "src/i18n/keys";
import { ReactElement } from "react";

// @ts-ignore importing svg
import emptyHome from "./emptyHome.svg";

import { Empty as StyledEmpty } from "./styles";

const EmptyPlaceholder = (): ReactElement => (
  <StyledEmpty>
    <p>{i18n.t(k.YOUR_HOME_SCREEN_HAS_NOT_BEEN)}</p>
    <img src={emptyHome} />
    <h2>{i18n.t(k.UNIFIZE_HOME_NOT_SET_UP)}</h2>
    <p>{i18n.t(k.CONTACT_YOUR_ORG_ADMIN_TO_SET)}</p>
  </StyledEmpty>
);

export default EmptyPlaceholder;
